export enum TagCategoryDefs {
  Size = 1,
  Style = 2,
  Collection = 4,
  Fashion = 6,
  Type = 14
}
